"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessTokenService = exports.accessTokenService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var pending_requests_registry_1 = require("../../pending-requests-registry");
var storage_service_1 = require("../storage-service");
var requestRoute = "accessToken";
var isDeviceAlreadyRegistered = function (storedTokens) {
    return storedTokens !== null;
};
var getAccessToken = function () {
    return storage_service_1.authSuiteDataLocalStorageService.getAccessTokens().then(function (tokens) {
        return isDeviceAlreadyRegistered(tokens) ? Promise.resolve(tokens) : registerNewDevice();
    });
};
var registerNewDevice = function () {
    var registeredRequest = pending_requests_registry_1.authSuitePendingRequestRegistry.getPendingRequest({
        requestKey: pending_requests_registry_1.PendingRequestKey.GET_ACCESS_TOKEN,
    });
    return registeredRequest || registerRequestAndFetchTokens();
};
var registerRequestAndFetchTokens = function () {
    var requestKey = pending_requests_registry_1.PendingRequestKey.GET_ACCESS_TOKEN;
    pending_requests_registry_1.authSuitePendingRequestRegistry.registerPendingRequest({
        pendingRequestPromise: fetchTokens(),
        requestKey: requestKey,
    });
    return pending_requests_registry_1.authSuitePendingRequestRegistry.getPendingRequest({ requestKey: requestKey });
};
var fetchTokens = function () {
    return auth_suite_fetch_1.authSuiteFetch
        .post({
        path: requestRoute,
    })
        .then(handleGetAccessTokenSuccess)
        .catch(handleGetAccessTokenError);
};
var handleGetAccessTokenSuccess = function (response) {
    storage_service_1.authSuiteDataLocalStorageService.setAccessTokens(response);
    clearRegisteredGetTokenRequest();
    return response;
};
var handleGetAccessTokenError = function (response) {
    clearRegisteredGetTokenRequest();
    return Promise.reject(response);
};
var clearRegisteredGetTokenRequest = function () {
    pending_requests_registry_1.authSuitePendingRequestRegistry.clearRegisteredRequest({ requestKey: pending_requests_registry_1.PendingRequestKey.GET_ACCESS_TOKEN });
};
exports.accessTokenService = {
    getAccessToken: getAccessToken,
};
var AccessTokenService = /** @class */ (function () {
    function AccessTokenService() {
        return exports.accessTokenService;
    }
    return AccessTokenService;
}());
exports.AccessTokenService = AccessTokenService;
